import * as React from "react";
import MUITabs from "@mui/material/Tabs";
import MUITab from "@mui/material/Tab";
import MUIBox from "@mui/material/Box";
import SC from "./style";

function CustomTabs({
  option = [],
  onChange = () => {},
  selectedValue = null,
  children,
  sx = {},
}) {
  return (
    <>
      <SC.GlobalStyles />
      <MUIBox
        sx={{
          maxWidth: { xs: 320, sm: 480, md: 960, lg: 1280 },
          bgcolor: "background.paper",
        }}
      >
        <MUITabs
          value={selectedValue}
          onChange={onChange}
          sx={sx}
          variant="scrollable"
          scrollButtons
          allowScrollButtonsMobile
          aria-label="scrollable force tabs example"
        >
          {option.map((item, index) => (
            <MUITab
              key={item.value}
              value={item}
              label={item.label}
              sx={{ textTransform: "capitalize", ...sx }}
            />
          ))}
        </MUITabs>
        {children && <MUIBox>{children}</MUIBox>}
      </MUIBox>
    </>
  );
}

export default CustomTabs;
